import styled from 'styled-components';

import { Text, TextElements } from '@calm-web/design-system';

interface ParagraphPackProps {
	id: string;
	text: string;
}

// 16px matches both platforms' actual paragraph-pack spacing intent — iOS's PackParagraphView
// uses a symmetric 8pt top+bottom padding (16pt total between adjacent packs); Android's
// equivalent layout sets no explicit margin at all, relying solely on the shared 20dp
// inter-item decorator every pack gets. 32px (units(4)) overshot both.
const Wrapper = styled.div`
	margin-bottom: 16px;
`;

const PackText = styled(Text).attrs({
	el: TextElements.P,
	noMargin: true,
	color: 'white',
})``;

const ParagraphPack = ({ id, text }: ParagraphPackProps) => {
	return (
		<Wrapper key={id}>
			<PackText>{text}</PackText>
		</Wrapper>
	);
};

export default ParagraphPack;
